import React, { useRef } from 'react'
// import { inspectionSteps } from '../../constants/dataList'
import SingleFlashcard from './singleFlashcard'
import { Swiper } from 'antd-mobile'
import { useFlashcard } from '../../zustand/handlers'
import { CustomIndicator } from './styles'
import SpeedController from '../../components/speedPopup'
import SpeedPopUp from '../../components/speedPopup'
import PlaylistPopUp from '../../components/playlistPopup'
import AudioTag from '../../components/audioTag'
import { useCategoryList } from '../../zustand/requests'

const colors = ['#ace0ff', '#bcffbd', '#e4fabd', '#ffcfac']

function FlashcardPage() {
    const flashcard = useFlashcard();
    const categories = useCategoryList();
    const inspectionSteps = categories?.data || [];

    const ref = useRef();
    // console.log(localStorage.getItem("audio"));

    let index = 0;
    return (
        <div>
            {!!inspectionSteps?.length &&
                <Swiper
                    ref={ref}
                    indicator={(total, current) => (
                        <CustomIndicator>
                            {`${current + 1} / ${total}`}
                        </CustomIndicator>
                    )}
                    defaultIndex={flashcard.current}
                    // indicator={() => null}
                    // direction='vertical' style={{ "--height": "200px" }}
                    direction='vertical'
                    // trackOffset={10}
                    // slideSize={80}
                    // stuckAtBoundary={false}
                    style={{ 'height': '100vh' }}
                    onIndexChange={(e) => {
                        console.log(e);
                        flashcard.setCurrent(e);
                    }}
                >

                    {categories?.data?.map(({ title: category, flashcards: items, name }, i) => (

                        items.map((data, j) => {
                            data = { ...data, i, j, category, name, index }
                            index++;
                            return (
                                <Swiper.Item key={Number(`${i}${j}`)}>
                                    <SingleFlashcard {...data} />
                                </Swiper.Item>
                            )
                        })
                    ))}
                </Swiper>}
            <SpeedPopUp />
            <PlaylistPopUp swiperRef={ref} />
            {/* <AudioTag /> */}
            {/* Flashcard */}
        </div>
    )
}

export default FlashcardPage